module.exports = __webpack_public_path__ + "img/post2.4d8e309d.jpg";